module.exports = __webpack_public_path__ + "img/st-2.39695519.png";